import type { CardType } from 'lib-shared-types-api';

import { CardsTest } from '../../../components/cardsTest/cardsTest';

type SettingsIntegrationsCardsCustomTestViewProps = { cardType: CardType };

export const SettingsIntegrationsCardsCustomTestView = ({
  cardType,
}: SettingsIntegrationsCardsCustomTestViewProps): JSX.Element => {
  return <CardsTest cardType={cardType} />;
};
